module.exports = __webpack_public_path__ + "img/ziyuan.7184a3e3.png";